import axios from 'plugins/axios'
import _clonedeep from 'lodash.clonedeep'

export const state = {
  list: null,
  initialize: false,
  differentDeliveryCustomer: false,
  paymentCustomer: {},
  deliveryCustomer: {},
  shippingRegulations: null,
  checkoutFormSettings: null
}

export const getters = {
  cart (state) {
    return state.list
  },
  countArticles (state) {
    // If the cart has not been initialized return null
    if (!state.list) return null
    return state.list.length
  },
  cartTotalPrice (state, getters, rootState, rootGetters) {
    // If the cart has not been initialized return null
    if (!state.list) return null
    // Map over all Articles and get their price
    let prices = state.list.map(article => {
      let product = rootGetters['products/getProductById'](article.product_id)
      // If the article is not a variation return the default price
      if (!article.variation_id) {
        if (product.use_discount_price) {
          return product.default_discount_price * article.amount
        }
        return product.default_price * article.amount
      }

      // otherwise return the price of the variation
      let variation = rootGetters['products/getVariationForProduct'](article.product_id, article.variation_id)
      if (!variation) return 0
      if (product.use_discount_price) {
        return variation.discount_price * article.amount
      }
      return variation.price * article.amount
    })

    return prices.reduce((sum, price) => sum + price, 0)
  },
  differentDeliveryCustomer (state) {
    return state.differentDeliveryCustomer
  },
  paymentCustomer (state) {
    return state.paymentCustomer
  },
  deliveryCustomer (state) {
    if (!state.differentDeliveryCustomer) {
      return state.paymentCustomer
    }
    return state.deliveryCustomer
  }
}

export const mutations = {
  initialize (state) {
    state.initialize = true
  },
  add (state, article) {
    if (state.initialize) {
      state.list = []
      state.initialize = false
    }

    let existingArticle = state.list.find(c => {
      return c.product_id === article.product_id && c.variation_id === article.variation_id
    })

    if (existingArticle) {
      existingArticle.amount += article.amount
      return existingArticle.amount
    }

    return state.list.push({
      product_id: article.product_id,
      variation_id: article.variation_id,
      amount: article.amount
    })
  },
  update (state, article) {
    state.list.splice(state.list.findIndex(c => {
      return c.product_id === article.product_id && c.variation_id === article.variation_id
    }), 1, article)
  },
  remove (state, article) {
    state.list.splice(state.list.indexOf(article), 1)
  },
  clear (state) {
    state.list = []
  },
  setDifferentDeliveryCustomer (state, differentDeliveryCustomer) {
    state.differentDeliveryCustomer = differentDeliveryCustomer
  },
  setPaymentCustomer (state, paymentCustomer) {
    state.paymentCustomer = paymentCustomer
  },
  setDeliveryCustomer (state, deliveryCustomer) {
    state.deliveryCustomer = deliveryCustomer
  }
}

export const actions = {
  async initialize ({state, dispatch, commit}, value) {
    state.differentDeliveryCustomer = value.differentDeliveryCustomer
    state.paymentCustomer = value.paymentCustomer
    state.deliveryCustomer = value.deliveryCustomer

    for (let article of value.list) {
      await dispatch('addArticle', article)
    }

    if (!state.list) {
      await commit('clear')
    }

    return state
  },
  async addArticle ({state, commit, dispatch}, article) {
    await dispatch('products/requestDetailed', article.product_id, {root: true})
    await commit('add', article)
  },
  updateArticle ({state, commit}, article) {
    commit('update', article)
  },
  removeArticle ({state, commit}, article) {
    commit('remove', article)
  },
  async getDeliveryCountries ({state, commit, getters, rootGetters}) {
    if (!state.shippingRegulations) {
      let {data} = await axios.get('/shipping-regulations')
      state.shippingRegulations = data.data
    }

    let shippingRegulations = state.shippingRegulations

    // only active regulations
    shippingRegulations = shippingRegulations.filter((regulation) => {
      return regulation
    })
    // otherwise it doesn't get correct value and causes wrong behaviour with country select
    let useWeight = rootGetters['shop/get'].use_weight
    if (useWeight === undefined) {
      let {data} = await axios.get('shops')
      useWeight = data.data.use_weight
    }

    // if system wide no weight - only options where the delivery_type is not "weight"
    if (!useWeight) {
      shippingRegulations = shippingRegulations.filter((regulation) => {
        regulation.options = regulation.options.filter((option) => {
          return option.delivery_type !== 'weight'
        })
        return regulation.options.length > 0
      })
    }
    return shippingRegulations
  },
  async getDeliveryOptions ({state, commit, getters, rootGetters}) {
    if (!state.shippingRegulations) {
      let {data} = await axios.get('/shipping-regulations')
      state.shippingRegulations = data.data
    }
    let deliveryCustomer = getters.deliveryCustomer

    // only options with the same country
    let availableOptions = state.shippingRegulations.filter(option => option.active && option.countries.includes(deliveryCustomer.country))
    let newvar = availableOptions

    // if system wide no weight - only options where the delivery_type is not "weight"
    if (!rootGetters['shop/get'].use_weight) {
      let copy = _clonedeep(availableOptions)
      newvar = copy.filter((regulation) => {
        regulation.options = regulation.options.filter((option) => {
          return option.delivery_type !== 'weight'
        })
        return regulation.options.length > 0
      })
    }

    return newvar
  },
  async getCheckoutFormSettings ({state, commit, getters, rootGetters}) {
    if (!state.checkoutFormSettings) {
      let {data} = await axios.get('/checkout-form')
      state.checkoutFormSettings = data.data
    }
    return state.checkoutFormSettings
  }
}



// WEBPACK FOOTER //
// ./client/store/cart.js